export default __webpack_public_path__ + "static/media/reward.fa731d19.svg";